import { Table } from "antd";
import Button from '../../Atoms/Button/Button';
import { useLocation } from 'wouter';

const columns = [
  {
    title: "Categorías",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Acciones",
    dataIndex: "actions",
    key: "actions",
    width: 100,
    fixed: 'right',
  },
];

const CategoryTable = () => {
  const [, setLocation ] = useLocation();

  const listCategories = [
    {
      key: 1,
      name: 'Nombre de categoría',
      actions: <Button small content="Editar" customClass="button s-large m-auto" type="primary" clickHandler={() => setLocation('/productos/categorias/editar/1')}/>
    },
    {
      key: 2,
      name: 'Nombre de categoría',
      actions: <Button small content="Editar" customClass="button s-large m-auto" type="primary" clickHandler={() => setLocation('/productos/categorias/editar/1')}/>
    },
    {
      key: 3,
      name: 'Nombre de categoría',
      actions: <Button small content="Editar" customClass="button s-large m-auto" type="primary" clickHandler={() => setLocation('/productos/categorias/editar/1')}/>
    },
    {
      key: 4,
      name: 'Nombre de categoría',
      actions: <Button small content="Editar" customClass="button s-large m-auto" type="primary" clickHandler={() => setLocation('/productos/categorias/editar/1')}/>
    },
    {
      key: 5,
      name: 'Nombre de categoría',
      actions: <Button small content="Editar" customClass="button s-large m-auto" type="primary" clickHandler={() => setLocation('/productos/categorias/editar/1')}/>
    }
  ]

  return (
    <>
      <Table columns={columns} dataSource={listCategories} pagination={false} />
    </>
  );
};

export default CategoryTable;
